import React, { useEffect, useState } from "react";
import { Box, Button, Divider, Drawer } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import { loadAction, loadAlert } from "redux/reducers/top";
import { loadWinnerAction } from "redux/reducers/event/index";
import { rem, eventDateFormat, renderNoti } from "assets/js/common";
import { useParams, useHistory } from "react-router-dom";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import FavoriteItem from "components/event/detail/favorite";
import { Cookies } from "react-cookie";
import AlertComplete from "components/ui/alert-complete";
import { getAppData } from "assets/js/apphandle";
import jwt_decode from "jwt-decode";
import Loading from "components/ui/loading";

const useStyles = makeStyles((theme) => ({
  detail: {
    "& .tit": {
      fontWeight: 700,
    },
    "& .sub-tit": {
      paddingTop: rem(6),
      fontSize: rem(14),
      color: theme.palette.text.disabled,
    },
    "& .date": {
      paddingTop: rem(7),
      fontSize: rem(12),
      color: theme.palette.text.disabled,
    },

    "& .info": {
      padding: "40px 30px",
      borderBottom: "1px solid #eee",
      "& table": {
        fontSize: rem(14),
        borderCollapse: "0",
        borderSpacing: "0",
        "& tr": {
          "& th": {
            display: "flex",
            width: rem(85),
            textAlign: "left",
            fontWeight: 800,
          },
          "& td": {
            wordBreak: "keep-all",
            lineHeight: rem(22),
          },
          "& + tr th, & + tr td": {
            paddingTop: rem(20),
          },
        },
      },
    },
    "& .bottom-wrap": {
      display: "flex",
      flexDirection: "column",
      "& button": {
        marginTop: `${rem(40)}`,
        "&.btnYellow": {
          backgroundColor: "#FFBB53",
        },
      },
    },
  },
}));

const cookies = new Cookies();

export default function EventWinner() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { seq } = useParams();

  const { schForm, winner, loading } = useSelector((state) => state.event);
  const { alertOpen, appCardOpen, favAlertOpen } = useSelector(
    (state) => state.top
  );

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState({ gift: "" });
  const [imgUrl, setImgUrl] = useState("");

  const openPopup = (token) => {
    if (token) {
      let decodedToken = jwt_decode(token);
      let info = winner.eventWinnerInfos.find(
        (info) => info.mbrNo == decodedToken.no
      );
      if (info) {
        setInfo(info);
        setDrawerOpen(true);
      } else {
        setOpen(true);
      }
    } else {
      dispatch(loadAlert(true));
    }
  };

  const checkWinnerInfos = () => {
    const token = cookies.get("X-AUTH-TOKEN");
    openPopup(token);
  };

  const handleFav = () => {
    axios
      .post("/api/eh/event-winner/like", {
        seq: seq,
      })
      .then((res) => {
        dispatch(loadWinnerAction(seq));
        console.log("event", event);
      });
  };

  useEffect(() => {
    if (moment(winner.expsEndYmd) < moment(moment().format("YYYYMMDD"))) {
      history.replace("/nopage");
    }
    if (seq == winner.seq) setImgUrl(winner.progImgUrl);
  }, [winner]);

  useEffect(() => {
    dispatch(loadWinnerAction(seq));
    // setDrawerOpen(true);
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "당첨자 발표", menu: false }));
  }, [init]);

  useEffect(() => {
    window.appBackKeyHandle = () => {
      if (alertOpen) {
        dispatch(loadAlert(false));
      } else if (open) {
        setOpen(false);
      } else if (drawerOpen) {
        setDrawerOpen(false);
      } else {
        history.goBack();
      }
    };
  });

  return (
    <>
      <Loading open={loading ? true : false} />
      <div className={classes.detail}>
        {winner && (
          <>
            <Box className="box-type-4">
              <div className="tit">{winner.ttl}</div>
              <div className="sub-tit">{winner.desc}</div>
              <div className="date">
                {eventDateFormat(winner.expsStrtYmd, winner.expsEndYmd)}
              </div>
            </Box>

            <Box pb={winner.noti ? 2 : 0}>
              {imgUrl && (
                <LazyCDNImage
                  cdnUrl={imgUrl}
                  style={{
                    width: "100%",
                    minHeight: "60vh",
                    borderRadius: "0",
                  }}
                />
              )}
            </Box>

            {winner.noti && (
              <Box className="box-type-1">
                <Box className="notice">
                  <p className="title">
                    <i className="ico-noti" />
                    유의사항
                  </p>
                  <ul className="list list-dot color-info font-14">
                    {renderNoti(winner.noti).map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </Box>
              </Box>
            )}

            <Divider />

            <Box className="box-type-1">
              <FavoriteItem mode={"event-winner"} item={winner} />
            </Box>

            <Box className="box-type-8">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={checkWinnerInfos}
              >
                당첨결과 확인하기
              </Button>
            </Box>
          </>
        )}

        <Drawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
          }}
          className="drawer-common-bottom size-small"
        >
          <div className="drawer-body">
            <div className="box-type-1 align-c" style={{ height: "275px" }}>
              <div className="illust">
                <img
                  src={`${process.env.PUBLIC_URL}/images/img/illust-winner.svg`}
                />
              </div>
              <p className="text" style={{ marginTop: rem(20) }}>
                <strong>
                  축하합니다!
                  <br />‘{info.gift}‘에 당첨되셨습니다
                </strong>
              </p>
              <Box component="span" className="count">
                자세한 사항은 안내사항 및<br />
                직접문의를 통해 확인하세요.
              </Box>
            </div>
          </div>
          <div className="drawer-foot">
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setDrawerOpen(false);
              }}
            >
              확인
            </Button>
          </div>
        </Drawer>
        <AlertComplete
          open={open}
          handleAlertClose={() => {
            setOpen(false);
          }}
          text="당첨된 내역이 없습니다."
          action={() => {
            setOpen(false);
          }}
        />
      </div>
    </>
  );
}
